import { Segmented } from '@myua/kit';
import React from 'react';
import { ExtensionDefinition, MediaType } from './model';
import { getViewerOptions } from './viewerChoice';

const LABELS: Partial<Record<MediaType, string>> = {
  [MediaType.Text]: 'JSON',
  [MediaType.Spine]: 'Spine',
};

const stop = (e: React.SyntheticEvent) => e.stopPropagation();

/**
 * Переключатель просмотрщика для расширений с alternativeViewers (MYUA-17117).
 * Клики не всплывают: в сайдбаре Asset Lab двойной клик по слоту открывает полноэкранный режим.
 */
export const ViewerSwitch: React.FC<{
  definition: ExtensionDefinition;
  value: MediaType;
  onChange: (mt: MediaType) => void;
  className?: string;
}> = ({ definition, value, onChange, className }) => (
  <div
    className={className}
    title="Режим просмотра: JSON или Spine-анимация"
    onClick={stop}
    onDoubleClick={stop}
    onMouseDown={stop}
  >
    <Segmented<MediaType>
      size="small"
      options={getViewerOptions(definition).map((mt) => ({ label: LABELS[mt] ?? mt, value: mt }))}
      value={value}
      onChange={onChange}
    />
  </div>
);
